var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-list-column',{staticClass:"column",attrs:{"format":_vm.format,"type":"stat"}},[_c('i',{staticClass:"fa fa-clock"})])}
var staticRenderFns = []

export { render, staticRenderFns }